export const INTERVALLE_ETP_OPTIONS = [
  { label: "jusqu'à 30% d'un ETP", value: "inf_30" },
  { label: "supérieure à 30% jusqu'à 50%", value: "sup_30__inf_50" },
  { label: "supérieure à 50% jusqu'à 70%", value: "sup_50__inf_70" },
  { label: "supérieure à 70% jusqu'à 90%", value: "sup_70__inf_90" },
  { label: "à temps plein", value: "temps_plein" },
];

export const YES_NO_OPTIONS = [
  { label: "Non", value: false },
  { label: "Oui", value: true },
];

export const TYPES = {
  MANDATAIRE_PRE: "prépose",
  MANDATAIRE_IND: "individuel",
  SERVICE: "service",
  prepose: "prépose",
  individuel: "individuel",
  service: "service",
};
